function restore (el) {
  const state = el.__throttleState;
  if (!state) return;

  clearTimeout(state.timeout);
  el.disabled = false;
  el.removeAttribute('aria-busy');
  if (state.text !== undefined) {
    el.innerText = state.text;
  }
  el.__throttleState = null;
}

const throttle = {
  bind (el, binding) {
    const handler = () => {
      if (el.disabled || el.__throttleState) return;

      const state = { text: el.innerText, timeout: /** @type {number | null} */ (null) };
      el.__throttleState = state;
      el.disabled = true;
      if (state.text !== undefined) {
        el.innerText = 'Loading…';
        el.setAttribute('aria-busy', 'true');
      }

      if (typeof binding.value === 'function') {
        Promise.resolve()
          .then(() => binding.value())
          .finally(() => restore(el))
          .catch(() => { });
        return;
      }

      state.timeout = setTimeout(() => restore(el), binding.arg || 1000);
    };

    el.__throttleHandler = handler;
    el.addEventListener('click', handler);
  },

  unbind (el) {
    if (el.__throttleHandler) {
      el.removeEventListener('click', el.__throttleHandler);
    }
    restore(el);
    el.__throttleHandler = null;
  },
};

export default throttle;
